function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GridRow from '../Grid/GridRow';
import GridColumn from '../Grid/GridColumn';
import ArrowLink from '../Links/ArrowLink';
import ModalCloseButton from './ModalCloseButton';
import ModalHeading from './ModalHeading';
import { px2rem, getDisplay } from '../../utils/helpers';
var Content = styled.div(_templateObject());
var BackContainer = styled.div(_templateObject2(), px2rem(36), getDisplay);
var CloseContainer = styled.div(_templateObject3(), getDisplay);

function ModalContent(_ref) {
  var id = _ref.id,
      title = _ref.title,
      onClose = _ref.onClose,
      children = _ref.children;
  var refCloseButton = useRef(null);
  useEffect(function () {
    if (refCloseButton.current !== null) {
      refCloseButton.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(GridRow, {
    pt: {
      m: 2
    },
    pl: {
      xs: 1
    }
  }, /*#__PURE__*/React.createElement(GridColumn, {
    size: {
      xs: 1
    }
  }, /*#__PURE__*/React.createElement(BackContainer, {
    display: {
      xs: 'block',
      m: 'none'
    }
  }, /*#__PURE__*/React.createElement(ArrowLink, {
    variant: "previous",
    onClick: onClose,
    mt: 1,
    tabIndex: 0
  }, "Retour")), /*#__PURE__*/React.createElement(CloseContainer, {
    display: {
      xs: 'none',
      m: 'flex'
    }
  }, /*#__PURE__*/React.createElement(ModalCloseButton, {
    ref: refCloseButton,
    onClick: onClose
  })))), /*#__PURE__*/React.createElement(GridRow, {
    pr: {
      xs: 1,
      m: 5
    },
    pb: {
      m: 3
    },
    pl: {
      xs: 1,
      m: 3
    }
  }, /*#__PURE__*/React.createElement(GridColumn, {
    size: {
      xs: 1
    }
  }, /*#__PURE__*/React.createElement(ModalHeading, {
    id: id + "-title"
  }, title), children)));
}

ModalContent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
} : {};
export default ModalContent;